module.exports = __webpack_public_path__ + "static/img/kddi_fs_logo.e7c07a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/kddi_fs_logo.jpg
// module id = ELX+
// module chunks = 0